
import { useEffect } from "react";
import { Grid } from "@mui/material";
import { AutocompleteNombre } from "../../components";
import { useProductosSoloTerminados } from "../../../hooks/cache";
import { useProductosStore } from "../../../stores";




export const AgregarTerminados = ({ formCarrito, setFormCarrito }) => {


    const { data=[] } = useProductosSoloTerminados();
    const { setActivarTerminado } = useProductosStore();


    useEffect(() => {
        return () => { setActivarTerminado(null) }
    }, [])

    
    const handleInputTerminados = (newValor) => {
        setFormCarrito({
            ...formCarrito,
            terminados: (newValor) ? newValor.id : null,
        });
        setActivarTerminado(newValor);
    }



    return (

        <Grid item xs={12} sx={{mt:1}}>
            <AutocompleteNombre
                size="small"
                label="Terminados"
                name="termina"
                value={formCarrito.terminados}
                onChange={ handleInputTerminados }
                options={data || []}
            />
        </Grid>
        
    )
}
